import { render, staticRenderFns } from "./ScheduledMessageList.vue?vue&type=template&id=2c794de7&scoped=true"
import script from "./ScheduledMessageList.vue?vue&type=script&lang=js"
export * from "./ScheduledMessageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c794de7",
  null
  
)

export default component.exports